import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
// Tabs
import ClientsEditTab from './Elements/ClientsEditTab';
import ClientFuelRefund from './Elements/ClientFuelRefund';
import ClientGroupTab from './Elements/ClientGroupTab';
import getLocale from '../../i18n/getLocale';

class ClientsEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      client_data: {},
      groups_data: {},
      fuel_refunds_data: {},
      country_list: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.refreshGroups = this.refreshGroups.bind(this);
    this.refreshFuelRefunds = this.refreshFuelRefunds.bind(this);
  }

  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/cliente/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/clientes');
        if (responseJson.status === 'success') {
          self.setState({client_data: responseJson.data.main});
          self.setState({flight_types_select: responseJson.data.flight_types_select});
          self.setState({fuel_refunds_data: responseJson.data.fuel_refunds_data});
        }
      }).then(() => {
      var url = config.get('api') + '/cliente/grupos/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({groups_data: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/paises/lista';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
            self.setState({country_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */ }); /* Lista países */}); /* Grupos do cliente */
    });
  }

  refreshGroups (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/cliente/grupos/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({groups_data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleAlert(event.message, event.status, 'open');
      }); /* Overlay */
    });
  }

  refreshFuelRefunds (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/cliente/reembolsos/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({fuel_refunds_data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleAlert(event.message, event.status, 'open');
      }); /* Overlay */
    });
  }

  render() {
    var key_control = 2;
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Clientes.EditarCliente.titulo}</h3>
      <Link to="/clientes" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title={this.locale.Clientes.EditarCliente.tabDadosDoCliente.tituloTab}>
          <ClientsEditTab handleAlert={this.handleAlert} refreshGroups={this.refreshGroups} client_id={this.props.match.params.id} country_list={this.state.country_list} client_data={this.state.client_data} groups_data={this.state.groups_data} />
        </Tab>
        {Object.keys(self.state.groups_data).map(function(k) {
          key_control++;
          return (
            <Tab eventKey={key_control} title={self.state.groups_data[k].name}>
              <ClientGroupTab RequestApi={self.refs.request_api} handleAlert={self.handleAlert} refreshGroups={self.refreshGroups} group_id={self.state.groups_data[k].id} group_data={self.state.groups_data[k]} />
            </Tab>
          );
        })}
      </Tabs>
    </div>
  </div>
</div>
    );
  }
}

export default ClientsEdit;



// WEBPACK FOOTER //
// ./src/Components/Clients/ClientsEdit.js